import { INFORMATION_SET_TRAINING } from "../../Actions/Information/InformationConstants";
import {
    changeSellScreenActionMode,
    changeSellScreenSummaryMode,
} from "../../Actions/SellScreen/SellScreenActions.tsx";
import { setOption, subscribeToOption } from "../../Utilities/Platform/Options/Options";
import { Application } from "../Application";
import { Bootstrapper } from "../Bootstrapper";
import type { ShopfrontDispatch } from "../hooks";

export class TrainingModeBootstrapper extends Bootstrapper {
    /**
     * @inheritDoc
     */
    public bootstrap(): void {
        const store = Application.get("Redux");

        // Subscribe to training mode setting
        subscribeToOption("register_training_sales_mode_enabled", (
            _,
            newValue,
            oldValue
        ) => {
            if(!newValue && oldValue) {
                store.dispatch({
                    type: INFORMATION_SET_TRAINING,
                    data: false,
                });

                setOption("training_mode_enabled", false);
            }
        });

        // Subscribe to training mode changes
        subscribeToOption("training_mode_enabled", (_, newValue, oldValue) => {
            if(newValue !== oldValue) {
                store.dispatch({
                    type: INFORMATION_SET_TRAINING,
                    data: newValue,
                });

                (store.dispatch as ShopfrontDispatch)(changeSellScreenActionMode("keys", {
                    clearBarcode: true,
                }));
                (store.dispatch as ShopfrontDispatch)(changeSellScreenSummaryMode("transaction"));
            }
        });
    }
}
